module.exports = __webpack_public_path__ + "img/screenfull-success.fbb4f244.png";